import api from './api';

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export interface Bank {
  id: number;
  name: string;
  enabled: boolean;
  created_by?: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
}

export interface CreateBankData {
  name: string;
  enabled?: boolean;
}

export const bankService = {
  async getAll(): Promise<Bank[]> {
    const response = await api.get('/banks');
    return unwrap<Bank[]>(response);
  },

  async getById(id: number): Promise<Bank> {
    const response = await api.get(`/banks/${id}`);
    return unwrap<Bank>(response);
  },

  async create(data: CreateBankData): Promise<Bank> {
    const response = await api.post('/banks', data);
    return unwrap<Bank>(response);
  },

  async update(id: number, data: Partial<CreateBankData>): Promise<Bank> {
    const response = await api.put(`/banks/${id}`, data);
    return unwrap<Bank>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/banks/${id}`);
  },
};

